import { Modal } from '@innovationdepartment/proxima-ui';
import DeleteTagConfirmationView from './DeleteTagConfirmationModal.View';

export type DeleteTagConfirmationModalProps = {
  open: boolean;
  close: () => void;
  confirm: () => void;
  tagDisplayName: string;
  isLoading?: boolean;
};

const DeleteTagConfirmationModal = ({
  open,
  confirm,
  close,
  tagDisplayName,
  isLoading = false
}: DeleteTagConfirmationModalProps) => (
  <Modal noPadding={false} open={open} title="Confirm Delete">
    <DeleteTagConfirmationView
      confirm={confirm}
      close={close}
      tagDisplayName={tagDisplayName}
      isLoading={isLoading}
    />
  </Modal>
);

export default DeleteTagConfirmationModal;
